import { concentrationPresentation } from '../../lib/concentrationResolver'

export function CatalogBottlePlaceholder({ className = 'h-14 w-11' }) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded bg-[radial-gradient(circle_at_50%_30%,rgba(201,168,76,0.16),rgba(34,34,34,0.98)_70%)] ${className}`}
      aria-label="No fragrance image available"
    >
      <svg viewBox="0 0 44 58" className="h-9 w-7 text-gold/35" fill="none" aria-hidden="true">
        <path d="M17 4h10v9l4 4c3 3 5 7 5 11v18c0 5-4 8-8 8H16c-4 0-8-3-8-8V28c0-4 2-8 5-11l4-4V4Z" stroke="currentColor" strokeWidth="2.5" />
        <path d="M15 4h14M12 36h20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M18 20h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".65" />
      </svg>
    </div>
  )
}

export function ConcentrationPill({ concentration, resolution = null, label = '', selectable = false }) {
  const presentation = resolution ? concentrationPresentation(resolution) : null
  const text = label || presentation?.display || concentration || 'Choose concentration'
  const conflictNote = label ? '' : presentation?.conflictNote
  return (
    <span className="mt-1 flex w-fit flex-col items-start gap-1">
      <span className="inline-flex items-center gap-1 rounded-full border border-gold/30 px-2 py-0.5 text-[10px] leading-none text-gold">
        {text}
        {(selectable || (!concentration && !resolution)) && <span aria-hidden>›</span>}
      </span>
      {conflictNote && (
        <span className="text-[10px] leading-tight text-amber-300/80">
          {conflictNote}
        </span>
      )}
    </span>
  )
}
